import $ from 'jquery'
import mod_analyse from "@/store/mods/clinique/analyses.js"
import mod_prestation from "@/store/mods/clinique/prestations.js"

export default {
    name: 'm-analyse',
    components: {},
    props: {
        user_id: Number,
        info_patient: Object,
        info_caissier: Object,
        refresh_state: Number,
        is_proforma: Boolean,
        proforma_id: Number,
        can_add_differential_computing: Object,
        format_ref_facture: String,
        selected_slug: String
    },
    data() {
        return {
            one_is_checked: [],
            save_loading: false,
            choice_is_empty: false,
            is_error: false,
            permission_is_denied: false,

            filter_analyse: '',
            filtered_analyses: [],
            selected_prestations: [],

            all_checked: false,
			each_cat_is_checked: [],
            text_grey: [],
            anl_is_loading: true,
            anl_is_empty: false,

            categoriesAnalyses: []
        }
    },

    watch: {
        filter_analyse() {
            this.filterAnalyse()
        },

        refresh_state() {
            if (this.selected_slug == 'analyse') {
                this.fetchAnalyse()
            }
        }
    },

    computed: {
        
    },

    mounted() {
        
    },

    methods: {
        fetchAnalyse() {
            this.anl_is_loading = true
            mod_analyse.getCategoriesAnalyse().then((categorie_analyses) => {
                this.categoriesAnalyses = categorie_analyses
                if (this.categoriesAnalyses.length == 0) {
                    this.anl_is_empty = true
                } else {
                    this.anl_is_empty = false
                    this.filtered_analyses = this.categoriesAnalyses
                }

                this.anl_is_loading = false
            }).catch(() => {
                this.anl_is_loading = false
                this.is_error = true
            })
        },

        onPriceUndefined() {
            this.warningToast("Le prix de cette analyse n'a pas été défini !")
        },

        submit() {
            if (this.one_is_checked.length == 0) {
                this.choice_is_empty = true
                return;
            }
            this.one_is_checked = this.setPrestationUID(this.one_is_checked)

            let data = {
                user_id: this.user_id,
                patient_id: this.info_patient.id,
                prestations: this.one_is_checked,
                type_prestation: 'Analyses',
                data_type: 'analyse',
                proforma_id: this.proforma_id,
                is_proforma: this.is_proforma,
                can_add_differential_computing: this.can_add_differential_computing.response,
                can_set_pac: this.can_set_pac,
                info_caissier: this.info_caissier,
                info_patient: {
                    nom_patient: this.info_patient.nom,
                    sexe: (this.info_patient.sexe == 'Masculin')?'H':'F',
                    telephone: this.info_patient.telephone_mobile,
                    num_dossier: this.info_patient.num_dossier,
                    age: this.info_patient.age
                },
                format_ref_facture: this.format_ref_facture
            }

            this.save_loading = true
            mod_prestation.getTarifPrestation(data).then((response) => {
                data = Object.assign(data, response)

                this.$store.dispatch('saveVentePrestation', data).then((response) => {
                    if (response.success) {
                        this.successToast('Ajout effectué avec succès')

                        this.$emit('emitPrestation', response.fpro_id)

                        this.one_is_checked = []
                        this.$refs.fpro_analyse.click()

                        if (response.fpro_id > 0) {
                            this.$router.push({ path: '/ventes/facture-proforma/'+response.fpro_id })
                        }
                    } else {
                        this.$refs.fpro_analyse.click()
                        this.dangerToast(response.message)
                    }

                    this.save_loading = false
                }).catch(() => {
                    this.save_loading = false
                    this.$refs.fpro_analyse.click()
                    this.dangerToast('Une erreur est survenue lors de l\'enregistrement. Veuillez réessayer plus tard.')
                })
            }).catch(() => {
                this.save_loading = false
                this.$refs.fpro_analyse.click()
                this.dangerToast('Une erreur est survenue lors du calcul des tarifs. Veuillez réessayer plus tard.')
            })
        },

        filterAnalyse() {
            this.filtered_analyses = [];

            if (this.filter_analyse == '') {
                this.filtered_analyses = this.categoriesAnalyses
            } else {
                this.categoriesAnalyses.forEach((categorie_analyse) => {
                    categorie_analyse.analyses.forEach(analyse => {
                        let cleaned_analyse = this.removeAccents(analyse.nom)
                        let cleaned_filter = this.removeAccents(this.filter_analyse)
    
                        if (cleaned_analyse.toLowerCase().includes(cleaned_filter.toLowerCase())) {
                            this.filtered_analyses.push(analyse)
                        }
                    });
                });
                
            }
        },

        /**
		 * Sélectionner / Déselectionner une catégorie de médicament
		 */
		touteCategorie(index) {
			let is_checked = $('#catanl-tous'+index).is(":checked")

            this.toggleCategorieChecked(is_checked, index)
		},

        toggleCategorieChecked(is_checked, index) {
            this.categoriesAnalyses.forEach((categorie_analyse) => {
                if (categorie_analyse.id == index) {
                    let one_price_is_undefined = false

                    categorie_analyse.analyses.forEach((_data) => {
                        this.text_grey[_data.id] = (is_checked)?'text-grey':''

                        const tmp_analyse = {
                            id: _data.id,
                            nom: _data.nom,
                            prix: _data.prix
                        }
                        if (is_checked) {
                            if (_data.prix == undefined || _data.prix == 0)  {
                                one_price_is_undefined = true
                            }

                            this.one_is_checked.push(tmp_analyse)
                        } else {
                            this.one_is_checked = this.one_is_checked.filter(item => item.id != tmp_analyse.id)
                        }
                    })

                    if (one_price_is_undefined) {
                        this.warningToast("Le prix d'une ou plusieurs analyses (décochée(s) dans la liste) n'a pas été défini !")
                    }
                }
            });
            
            this.all_checked = is_checked
        },
    }
}


